import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';

import { SEND_DELIVERABLE_ALL } from './constants';
import { getUserId } from '../../selectors/user-selectors';
import { getCampaignId, getPermissionId } from '../../selectors/campaign-selectors';
import { sendbirdSendDeliverableAll } from '../../utils/sendbird-send-all-service';
import { MODAL_LOADING, MODAL_ERROR } from '../../constants/modal';
import { RELOAD_DISCUSSIONS } from '../../containers/discussion-list/constants';
import { reportError } from '../../utils/error-handling-service';

export function* sendDeliverableAll(action) {
  try {
    yield put({ type: MODAL_LOADING, loading: true });

    const deliverableData = action.data;
    const callback = action.callback;

    const userId = yield select(getUserId);
    const campaignId = yield select(getCampaignId);
    const permissionId = yield select(getPermissionId);

    const data = {
      userId,
      campaignId,
      permissionId,
      message: 'deliverable',
      deliverableData,
    };

    const response = yield call(sendbirdSendDeliverableAll, data);

    yield put({ type: RELOAD_DISCUSSIONS, data: { campaignId } });
    if (callback) callback();

  } catch (error) {
    reportError('SEND_DELIVERABLE_ALL_ERROR', error.message);
    yield put({ type: MODAL_ERROR, error: error.message });
  }
}

export function* watchSendDeliverableAll() {
  yield takeLatest(SEND_DELIVERABLE_ALL, sendDeliverableAll);
}

export default function* sendDeliverableAllSagas() {
  yield [
    fork(watchSendDeliverableAll)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/containers/send-deliverable-all-modal/sagas.js
 **/